import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader";
import Calling from "../../api/Calling";
import { toast } from "react-toastify";
import DeleteButton from "../../components/ul/DeleteButton";
import generateCaptcha from "../../components/captcha";
import formatDateTime from "../../components/formatDateTime";
import { useNavigate, useParams } from "react-router-dom";
import NotFound from "../../components/ul/NotFound";
import { MdDone } from "react-icons/md";
import { FaUserCircle } from "react-icons/fa";
import img1 from "../../Image/Profile.png";

const WithdrawInfo = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const fetchData = async () => {
        setLoader(true);
        try {
          const response = await Calling.GetUserWithdraw(
            "",
            "",
            "",
            "",
            "",
            id,
            ""
          );
          if (response?.status) {
            setData(response?.data);
          } else {
            toast.error(response?.message);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          toast.error("Something went wrong!");
        } finally {
          setLoader(false);
        }
      };
      fetchData();
    }
  }, [id]);

  const handleDelete = async () => {
    if (!data) return;

    try {
      setLoader(true);
      const response = await Calling.DeleteUserWithdraw({ id: [data._id] });
      if (response?.status) {
        toast.success(response?.message);
        navigate(-1);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Error deleting:", error);
      toast.error("Failed to delete!");
    } finally {
      setLoader(false);
    }
  };

  const handleAccept = async () => {
    try {
      setLoader(true);
      const response = await Calling.UserWithdrawAccept({ id: [data._id] });
      if (response?.status) {
        toast.success(response?.message);
        navigate(-1);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Error deleting:", error);
      toast.error("Failed to delete!");
    } finally {
      setLoader(false);
    }
  };
  const handleUser = () => {
    if (data?.u_info) {
      navigate(`/manage/user/all/info/${data?.u_info?._id}`);
    } else {
      toast.error("User information is not available!");
    }
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : data ? (
        <div className="w-full flex justify-center items-center min-h-screen bg-gradient-to-br from-blue-600 to-indigo-800 p-4 sm:p-8">
          <div className="bg-white/90 backdrop-blur-md shadow-lg rounded-2xl p-6 sm:p-10 max-w-lg sm:max-w-3xl w-full text-gray-900">
            <h1 className="text-2xl sm:text-4xl font-extrabold text-center text-gray-800 mb-4 sm:mb-6 flex justify-center items-center gap-2">
              Withdraw Information
              <button
                onClick={handleUser}
                className="text-blue-500 hover:text-blue-700 transition flex items-end pt-2"
              >
                <img
                  src={data?.u_info?.u_profile || img1}
                  className="ms-2 w-8 h-8 sm:w-10 sm:h-10 rounded-full"
                />
              </button>
            </h1>

            <hr className="mb-4 sm:mb-6 border-gray-300" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 text-sm sm:text-lg">
              <div className="space-y-3 sm:space-y-4">
                <p>
                  <strong>Name:</strong> {data.u_Name}
                </p>
                <p>
                  <strong>Withdraw Coins:</strong> {data.u_wcoin}
                </p>
                <p>
                  <strong>Total Coins After Withdraw:</strong> {data.total_coin}
                </p>
                <p>
                  <strong>Type:</strong> {data.u_type}
                </p>
                <p className="text-lg sm:text-xl font-semibold text-green-600">
                  {data.u_amount_type === "rs" ? "₹" : "$"}
                  {data.u_Amount}
                </p>
              </div>
              <div className="space-y-3 sm:space-y-4">
                <p>
                  <strong>Created :</strong>{" "}
                  <span className="text-blue-500">
                    {formatDateTime(data.createdAt)}
                  </span>
                </p>
                <p>
                  <strong>Status:</strong>
                  <span
                    className={`ml-2 px-2 sm:px-3 py-1 rounded-lg text-white text-xs sm:text-sm ${
                      data.status ? "bg-green-500" : "bg-red-500"
                    }`}
                  >
                    {data.status ? "Completed" : "Pending"}
                  </span>
                </p>
                {data.u_type === "Upi" && (
                  <p>
                    <strong>UPI ID:</strong> {data.u_Upi}
                  </p>
                )}
                {data.u_type === "Bank" && (
                  <>
                    <p>
                      <strong>Bank Name:</strong> {data.u_Bank_Name}
                    </p>
                    <p>
                      <strong>Account Holder:</strong> {data.u_Bank_AHN}
                    </p>
                    <p>
                      <strong>IFSC Code:</strong>{" "}
                      <span className="text-indigo-500">
                        {data.u_Bank_IFSC}
                      </span>
                    </p>
                    <p>
                      <strong>Bank Account:</strong> {data.u_Bank_AC}
                    </p>
                  </>
                )}
                {data.u_type === "Paypal" && (
                  <p>
                    <strong>Paypal Email:</strong> {data.u_email}
                  </p>
                )}
                {data.u_type === "Binance" && (
                  <div className="text-sm">
                    <strong>Binance ID:</strong> {data.u_binance || "-"}
                  </div>
                )}
              </div>
            </div>
            <div className="mt-6 sm:mt-8 flex justify-center gap-3 sm:gap-4">
              {!data?.status && (
                <button
                  className="bg-green-500 flex items-center justify-center text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg shadow-md hover:bg-green-600 transition transform hover:scale-105"
                  onClick={handleAccept}
                >
                  <MdDone className="me-1 sm:me-2" size={16} />
                  Accept
                </button>
              )}
              <DeleteButton
                onClick={handleDelete}
                label="Delete"
                className="bg-red-500 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg shadow-md hover:bg-red-700 transition transform hover:scale-105"
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <NotFound />
        </div>
      )}
    </>
  );
};

export default WithdrawInfo;
